import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import { useState, useCallback, useRef, useEffect, useReducer, useDebugValue } from 'react';
import { getFieldId } from '@commercetools-uikit/utils';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _reverseInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reverse';
import sortBy from 'lodash/sortBy';
import isNil from 'lodash/isNil';

var useToggleState = function useToggleState(defaultValue) {
  var initialValue = typeof defaultValue === 'boolean' ? defaultValue : true;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      isToggled = _useState2[0],
      setIsToggled = _useState2[1];

  var toggle = useCallback(function (forceIsToggled) {
    setIsToggled(typeof forceIsToggled === 'boolean' ? forceIsToggled : !isToggled);
  }, [isToggled, setIsToggled]);
  return [isToggled, toggle];
};

var useToggleState$1 = useToggleState;

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

var usePrevious$1 = usePrevious;

var useFieldId = function useFieldId(id, createIdFn) {
  var _useState = useState(id),
      _useState2 = _slicedToArray(_useState, 2),
      internalId = _useState2[0],
      setId = _useState2[1];

  useEffect(function () {
    var props = {
      id: id
    };
    var state = {
      id: internalId
    };
    setId(getFieldId(props, state, createIdFn));
  }, [id, internalId, setId, createIdFn]);
  return internalId;
};

var useFieldId$1 = useFieldId;

function ownKeys$2(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$2(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$2(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getInitialState$1 = function getInitialState(keyName, rows) {
  return _reduceInstanceProperty(rows).call(rows, function (items, currentItem) {
    // @ts-ignore: index signature is confused as items might contain the initial value.
    var initialValue = currentItem[keyName];
    return _objectSpread$2(_objectSpread$2({}, items), {}, _defineProperty({}, currentItem.id, initialValue !== null && initialValue !== void 0 ? initialValue : false));
  }, {});
};

function selectionReducer(state, action) {
  switch (action.type) {
    case 'toggle':
      return _objectSpread$2(_objectSpread$2({}, state), {}, _defineProperty({}, action.payload, !state[action.payload]));

    case 'select':
      return _objectSpread$2(_objectSpread$2({}, state), {}, _defineProperty({}, action.payload, true));

    case 'deselect':
      return _objectSpread$2(_objectSpread$2({}, state), {}, _defineProperty({}, action.payload, false));

    case 'selectAll':
      {
        var _context;

        return _reduceInstanceProperty(_context = _Object$keys(state)).call(_context, function (allItems, currentItem) {
          return _objectSpread$2(_objectSpread$2({}, allItems), {}, _defineProperty({}, currentItem, true));
        }, {});
      }

    case 'deselectAll':
      {
        var _context2;

        return _reduceInstanceProperty(_context2 = _Object$keys(state)).call(_context2, function (allItems, currentItem) {
          return _objectSpread$2(_objectSpread$2({}, allItems), {}, _defineProperty({}, currentItem, false));
        }, {});
      }

    default:
      return state;
  }
}

var useRowSelection = function useRowSelection(keyName, rows) {
  var _useReducer = useReducer(selectionReducer, getInitialState$1(keyName, rows)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      selectionState = _useReducer2[0],
      dispatch = _useReducer2[1];

  useDebugValue(selectionState);

  var selectableRows = _mapInstanceProperty(rows).call(rows, function (item) {
    return _objectSpread$2(_objectSpread$2({}, item), {}, _defineProperty({}, keyName, selectionState[item.id]));
  });

  var toggleRow = function toggleRow(id) {
    return dispatch({
      type: 'toggle',
      payload: id
    });
  };

  var selectRow = function selectRow(id) {
    return dispatch({
      type: 'select',
      payload: id
    });
  };

  var deselectRow = function deselectRow(id) {
    return dispatch({
      type: 'deselect',
      payload: id
    });
  };

  var selectAllRows = function selectAllRows() {
    return dispatch({
      type: 'selectAll'
    });
  };

  var deselectAllRows = function deselectAllRows() {
    return dispatch({
      type: 'deselectAll'
    });
  };

  var getIsRowSelected = function getIsRowSelected(id) {
    return selectionState[id];
  };

  var getNumberOfSelectedRows = function getNumberOfSelectedRows() {
    return _reduceInstanceProperty(selectableRows).call(selectableRows, function (count, item) {
      return count + (item[keyName] === true ? 1 : 0);
    }, 0);
  };

  return {
    rows: selectableRows,
    toggleRow: toggleRow,
    selectRow: selectRow,
    deselectRow: deselectRow,
    selectAllRows: selectAllRows,
    deselectAllRows: deselectAllRows,
    getIsRowSelected: getIsRowSelected,
    getNumberOfSelectedRows: getNumberOfSelectedRows
  };
};

var useRowSelection$1 = useRowSelection; // we're using lodash sortBy as our default sorting fn

var sortItems = function sortItems(items, field, sortDirection) {
  var sortingFunction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : sortBy;

  if (!field) {
    return items;
  }

  var sortedItems = sortingFunction(items, field);

  if (sortDirection === 'desc') {
    return _reverseInstanceProperty(sortedItems).call(sortedItems);
  }

  return sortedItems;
};

var getInitialState = function getInitialState(items, field, sortDirection, sortingFunction) {
  return {
    items: sortItems(items, field, sortDirection, sortingFunction),
    sortedBy: field,
    sortDirection: sortDirection
  };
};

var useSorting = function useSorting(items, field, sortDirection, sortingFunction) {
  var _useState = useState(function () {
    return getInitialState(items, field, sortDirection, sortingFunction);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      sortState = _useState2[0],
      setSorting = _useState2[1];

  useDebugValue(sortState);

  function onSortChange(fieldKey) {
    var nextSortDirection;
    var sortedItems;

    if (sortState.sortedBy !== fieldKey) {
      // if the intented field is not already sorted, the initial direction is 'asc'
      nextSortDirection = 'asc';
      sortedItems = sortItems(sortState.items, fieldKey, nextSortDirection);
    } else {
      var _context;

      nextSortDirection = sortState.sortDirection === 'asc' ? 'desc' : 'asc';
      sortedItems = _reverseInstanceProperty(_context = sortState.items).call(_context);
    }

    setSorting({
      items: sortedItems,
      sortedBy: fieldKey,
      sortDirection: nextSortDirection
    });
  }

  return {
    items: sortState.items,
    sortedBy: sortState.sortedBy,
    sortDirection: sortState.sortDirection,
    onSortChange: onSortChange
  };
};

var useSorting$1 = useSorting;

function ownKeys$1(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys$1(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys$1(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var applyIf$1 = function applyIf(values, key) {
  return !isNil(values[key]) ? _defineProperty({}, key, values[key]) : {};
};

var defaultValues$1 = {
  page: 1,
  perPage: 20
};

var usePaginationState = function usePaginationState() {
  var initialValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mergedValues = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, defaultValues$1), applyIf$1(initialValues, 'page')), applyIf$1(initialValues, 'perPage'));

  var _useState = useState(mergedValues.page),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = useState(mergedValues.perPage),
      _useState4 = _slicedToArray(_useState3, 2),
      perPage = _useState4[0],
      setPerPage = _useState4[1];

  var onPageChange = useCallback(function (nextPage) {
    setPage(nextPage);
  }, [setPage]);
  var onPerPageChange = useCallback(function (nextPerPage) {
    // side-effect:
    // GIVEN client updates `perPage`,
    // THEN we reset `page` (discards initialValues.page)
    setPage(1);
    setPerPage(nextPerPage);
  }, [setPerPage, setPage]);
  return {
    page: {
      value: page,
      onChange: onPageChange
    },
    perPage: {
      value: perPage,
      onChange: onPerPageChange
    }
  };
};

var usePaginationState$1 = usePaginationState;

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultValues = {
  key: 'createdAt',
  order: 'desc'
};

var applyIf = function applyIf(values, key) {
  return !isNil(values[key]) ? _defineProperty({}, key, values[key]) : {};
};

var useDataTableSortingState = function useDataTableSortingState() {
  var initialValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mergedValues = _objectSpread(_objectSpread(_objectSpread({}, defaultValues), applyIf(initialValues, 'key')), applyIf(initialValues, 'order'));

  var _useState = useState(mergedValues),
      _useState2 = _slicedToArray(_useState, 2),
      sortDefinition = _useState2[0],
      setSortDefinition = _useState2[1];

  var onTableSortingChange = useCallback(function (key, order) {
    setSortDefinition({
      key: key,
      order: order
    });
  }, []);
  return {
    value: sortDefinition,
    onChange: onTableSortingChange
  };
};

var useDataTableSortingState$1 = useDataTableSortingState; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { useDataTableSortingState$1 as useDataTableSortingState, useFieldId$1 as useFieldId, usePaginationState$1 as usePaginationState, usePrevious$1 as usePrevious, useRowSelection$1 as useRowSelection, useSorting$1 as useSorting, useToggleState$1 as useToggleState, version };